export default {
  title: 'Profile Settings',
  subtitle: 'Your address, language, password and sign-in security',
  email: {
    title: 'Email address',
    change: 'Change',
    dialogTitle: 'Change your email address',
    newEmail: 'New email address',
    submit: 'Send the confirmation',
    sent: 'A code and a link are on their way to {email}. Enter the code here, or open the link: nothing changes until you do.',
    code: 'Confirmation code',
    confirm: 'Confirm',
    changed: 'Your email address has changed.',
    invalidAddress: 'This address cannot be used: check it, and that it is not already yours.',
    invalidCode: 'This code is not valid any more. Ask for the change again.',
    cancel: 'Cancel',
    close: 'Close',
  },
  language: {
    title: 'Language',
    select: 'Select language',
    saved: 'Language saved',
  },
  password: {
    title: 'Password',
    change: 'Change password',
    new: 'New password',
    confirm: 'Confirm new password',
    update: 'Update password',
    cancel: 'Cancel',
    changed: 'Your password has changed. Your other sessions were signed out.',
    tooShort: 'At least {min} characters',
    tooLong: 'At most {max} characters',
    mismatch: 'The two passwords differ',
    invalid: 'This password cannot be used.',
    closed: 'Password sign-in is not available on this platform.',
  },
  twoFactor: {
    title: 'Two-step verification',
    off: 'Off. Turn it on to be asked for a code from your phone each time you sign in.',
    turnOn: 'Turn on',
    turnOff: 'Turn off',
    authenticator: 'Authenticator app',
    added: 'Added {date}',
    lastUsed: 'last used {date}',
    neverUsed: 'not used yet',
    recoveryRemaining: '{count} recovery code left | {count} recovery codes left',
    noRecovery: 'You have no recovery codes left: without one, losing your phone locks you out. Make new ones.',
    regenerate: 'New recovery codes',
    enrolTitle: 'Turn on two-step verification',
    recoveryTitle: 'Your recovery codes',
    regenerateTitle: 'New recovery codes',
    regenerateExplain:
      'Enter a code from your app, or one of your recovery codes. The recovery codes you have now will stop working.',
    removeTitle: 'Turn off two-step verification',
    removeExplain: 'Enter a code from your app, or one of your recovery codes. Your recovery codes go with it.',
    code: 'Code',
    submitRegenerate: 'Make new codes',
    submitRemove: 'Turn off',
    cancel: 'Cancel',
    removed: 'Two-step verification is off.',
    invalidCode: 'That code did not work. Try again.',
    required:
      'Two-step verification is required on this platform or by one of your organizations, so it cannot be turned off.',
    noFactor: 'Two-step verification is not on for this account.',
    unavailable: 'Two-step verification is not available on this platform.',
    loadError: 'Your two-step verification settings could not be read.',
  },
  sessions: {
    title: 'Where you are signed in',
    current: 'This session',
    unknownDevice: 'Unknown device',
    signedIn: 'signed in {date}',
    lastActive: 'Active {date}',
    revoke: 'Sign out',
    revokeOthers: 'Sign out everywhere else',
    revoked: 'That session is signed out.',
    othersRevoked: 'Every other session is signed out.',
    loadError: 'Your sessions could not be read.',
  },
  danger: {
    title: 'Danger Zone',
    description: 'Irreversible and destructive actions',
    warning:
      'Deleting your account signs you out everywhere and removes you from every organization. It is refused while you are the last member able to administer an organization: delete it first, or hand it to another member.',
    organizationsTitle: 'You own {count} organization | You own {count} organizations',
    deleteAccount: 'Delete my account',
    deleteOrganization: 'Delete the organization',
  },
}
